const tableroUrlWS = window.config.Statics.TableroUrl;
const pathDatosUrl = "obtenerTableros/procesarTablero/";
const pathCambiosWS = "obtenerCC/procesarCC/";
let isDebugging = false;
let tableros = [];

/* CodigoControl*/ /////////////////////////////////////////////////////////////////////////////
var codigoControl =
    function (encuentroId, codigoControl) {
//console.log("this " + this)
        this._encuentroId = encuentroId,
            this._codigo = parseInt("0x" + codigoControl, 16),
            this._encuentro = (0x0000000F & this._codigo),
            this._incidencias = (0x0000FFF0 & this._codigo) >> 4,
            this._formaciones = (0x000F0000 & this._codigo) >> 16,
            this._imagenes = (0x0FF00000 & this._codigo) >> 20,
            this._tablero = (0xF0000000 & this._codigo) >> 28,


            this.encuentroId = function () {
                return this._encuentroId;
            },
            this.incidencias = function () {
                return this._incidencias;
            },
            this.encuentro = function () {
                return this._encuentro;
            },
            this.formaciones = function () {
                return this._formaciones;
            },
            this.imagenes = function () {
                return this._imagenes;
            },
            this.tablero = function () {
                return this._tablero;
            },
            this.isTypeOf = function (value) {
                var _isTypeCodigoControl = false;
                if (value == "codigoControl")
                    _isTypeCodigoControl = !_isTypeCodigoControl;
                return _isTypeCodigoControl;
            }
        return false;
    };

/* metodo que recibe un array en notacion json ej: {"cc":[{"id":000,"valor":001},{..},{..}]} */
/* lo convierte en array de objetos tipo CodigoControl */
function factoryCodigoControl(arr) {
    var list = new Array();
  //  console.log("factoryCodigoControl")
    try {
        for (var x = 0; x <= arr.length - 1; x++) {
            var codControl = new codigoControl(arr[x].id, arr[x].valor);
            list.push(codControl);
        }
    }
    catch (err) {
        if (isDebugging) { showError('factoryCodigoControl', err) };
    }
    return list;
};

/*recibe una lista de objetos de tipo ComparadorCodigoControl*/
/*devuelve una lista de objetos CodigoSolicitud concatenados */
function generarUrlParamCodigoSolicitud(arr) {
    try {
        var list = new Array();
        for (var x = 0; x <= arr.length - 1; x++) {
            var cs = new codigoSolicitud(arr[x].cambiosEncuentro(), arr[x].cambiosIncidencias(), arr[x].cambiosFormaciones());
            // verifico si hay cambios.                             
            if (!cs.allFalse()) {
                list.push(arr[x].encuentroId() + "-" + cs.toString() + "1");
            };
        }
        /// agregar la validacion de todos, que hago si ninguno va?
        return list.toString();
    }
    catch (err) {
        if (isDebugging) { showError('generarUrlParamCodigoSolicitud', err) };
        return "";
    }
};

/*recibe dos objetos de tipo CodigoControl y permite comparlos*/
var comparadorCodigoControl =
    function (old, newslast) {
      //  console.log("comparadorCodigoControl")
        this.encuentroId = function () {
                return old.encuentroId();
            },
            this.cambiosIncidencias = function () {
                var _hayCambios = false;
                if (old.incidencias() != newslast.incidencias())
                { _hayCambios = !_hayCambios }
                return _hayCambios;
            },
            this.cambiosFormaciones = function () {
                var _hayCambios = false;
                if (old.formaciones() != newslast.formaciones())
                { _hayCambios = !_hayCambios }
                return _hayCambios;
            },
            this.cambiosEncuentro = function () {
                var _hayCambios = false;
                if (old.encuentro() != newslast.encuentro())
                { _hayCambios = !_hayCambios }
                return _hayCambios;
            }
    };

/*recibe los parametros (booleans) relacionados con los cambios en el nuevo codigo de control*/
/*devuelve la concatenacion*/
var codigoSolicitud =
    function (e, i, f) {
        this.allFalse = function () {
            var _allFalse = false;
            if ((!e) && (!i) && (!f)) { _allFalse = !_allFalse; }
            return _allFalse;
        };

        var convert = function (value) {
            var _hasValue = '0';
            if (value) { _hasValue = '1'; }
            return _hasValue;
        };

        this.toString = function () {
            return (convert(e) + convert(i) + convert(f));
        }
    };




/*agrega un objeto de tipo tablero a el array tableros*/
function agregarTablero(value) {
    tableros.push(value);
};


/* procesa el codigo de control verificando que tipo de cambios hubo */
/* solicitando la actualizacion de los tableros*/
window.procesarCC = function(json) {
   // console.log("procesarCC")
    try {
        // array de objetos comparador // 
        var _arrComparador = new Array();

        // creo los codigo de control //
        var _arr = factoryCodigoControl(json);

        // comparo los codigos de control //
        for (var i = 0; i < _arr.length; i++) {
            //console.log("buscarTablero")
            var oTablero = buscarTablero(_arr[i].encuentroId());
            //console.log("actualizarReloj")
            oTablero.actualizarReloj();
            //console.log("codigoControl")
            var oCCOld = new codigoControl(oTablero._value.cc.id, oTablero._value.cc.valor);
            // comparo los codigo de control, el que tengo y el actualizado //
            var oComparador = new comparadorCodigoControl(oCCOld, _arr[i]);
            _arrComparador.push(oComparador);
        }
        //console.log("generarUrlParamCodigoSolicitud")
        var _param = generarUrlParamCodigoSolicitud(_arrComparador);

        /*solicito la actualizacion de los tableros*/
        /*siempre y cuando existan tableros para actualizar*/
        if (_param != "") {
            //console.log("actualizarTablero")
            actualizarTablero(_param);
        }

    }
    catch (err) {
        if (isDebugging) { showError('procesarCC', err) };
    }
};

export const verificarCambiosCodigoControl = () => {
    //console.log("verificarCambiosCodigoControl")
    // tomo todos los objeto de tipo tablero de tableros[] //
    var _arr = new Array();

    try {
        //obtengo los codigo de control y defino que voy a pedir // 
        for (var i = 0; i < tableros.length; i++) {
            // armo la url con el encuentroId - cc //
            var _cadena = tableros[i]._value.cc.id;
            if (tableros[i]._estaActivo) {
                _arr.push(_cadena);
            }
        }
        if (_arr.length > 0) {
            //console.log("parametros " + tableroUrlWS + pathCambiosWS + _arr.toString())
            var obj = new Object();
            obj.url = tableroUrlWS + pathCambiosWS;
            obj.pars = _arr.toString(); // recibe un cadena de ids o un objeto tablero??
            var ajaxConexion = new ajaxData(obj);
            ajaxConexion.conectar();
        }

    }
    catch (err) {
        if (isDebugging) { showError('verificarCambiosCodigoControl', err) };
    }

};


/*busca un objeto de tipo tablero dentro del array tableros*/
function buscarTablero(value) {
    //console.log("buscarTablero")
    var oTablero = null;
    try {
        for (var i = 0; i < tableros.length; i++) {
            if (tableros[i]._value.cc.id == value) {
                oTablero = tableros[i];
            }
        }

    }
    catch (err) {
        if (isDebugging) { showError('buscarTablero', err) };
    }
    return oTablero;
};



function showError(m, e) {
    alert("metodo: " + m + ", error = " + e);
}

var ajaxData = function(options) {
        this._pars = options.pars,
            this._url = options.url,
            this._metodoCallBack = options.metodoCallBack,
            this.conectar = function() {
                $.ajax({
                    dataType: "jsonp",
                    url: this._url + this._pars,
                    success: function(json) {}
                });
            }
}
window.procesarTablero = function (json) {
    //console.log("procesarTablero")
    /*este metodo tiene que recibir un json que actualice los tableros*/
    var _arr = new Array();
    try {
        _arr = json;
        for (var i = 0; i < _arr.length; i++) {
            if (_arr[i].hasOwnProperty('cc')) {
                var oTablero = buscarTablero(_arr[i].cc.id);
                if (oTablero == null) {
                    throw err;
                }
                else {
                    oTablero.setValue(_arr[i]);
                }
                oTablero.execute();
            }
        };
    }
    catch (err) {
        if (isDebugging) { showError('procesarTablero', err) };
    }
};

/*recibe una cadena con el codigo de encuentro y el codigo de solicitud ej: 2375-111,,, */
function actualizarTablero(value) {
    try {
        /*tiene que haber una llamada al ws verificando si existen cambios para que se actualice*/
        var obj = new Object();
        obj.url = tableroUrlWS + pathDatosUrl;
        obj.pars = value; // recibe un cadena de ids
        var ajaxConexion = new ajaxData(obj);
        ajaxConexion.conectar();
    }
    catch (err) {
        if (isDebugging) { showError('actualizarTablero', err) };
    }
};

/*actualiza el tiempo de los tableros*/
function actualizarTiempo() {
    try {
        for (var i = 0; i < tableros.length; i++) {
            tableros[i].actualizarReloj();
        }
    }
    catch (err) {
        if (isDebugging) { showError('actualizarTiempo', err) };
    }
}

export const iniciarTableros = (tablerosParam) => {
    try {
        tableros = tablerosParam;
        var _cadena = new Array();
        for (var i = 0; i < tableros.length; i++)  {
            _cadena.push(tableros[i]._value.cc.id + "-" + tableros[i]._value.cc.valor);
        }
        //console.log(_cadena.toString())
        actualizarTablero(_cadena.toString());
        //a partir de aca, una vez que se actualiza por primera vez el tablero
        // setear un intervalo de tiempo para un metodo que actualice el tiempo en los tableros.
        setInterval(actualizarTiempo, 1000);

    }
    catch (err) {
        if (isDebugging) { showError('iniciarTableros', err) };
    }
}





// WEBPACK FOOTER //
// ./Statics/scripts/common/tableros.js